import axios from 'axios'
import session from './session'
import { getAuthContext } from './authContext'
import router from '../router'
import store from '../store'

const instance = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL,
  timeout: 10000
})

//request
instance.interceptors.request.use(
  (config) => {
    const token = session.get('token')
    if (config.skipSsoAuth) delete config.headers.authorization
    else if (token) config.headers.authorization = `Bearer ${token}`
    return config
  },
  (err) => {
    return Promise.reject(err)
  }
)

//response
instance.interceptors.response.use(
  (response) => {
    return response
  },
  (err) => {
    const { status, data } = err.response || {}
    if (status == 452) {
      store.dispatch('app/A_error', data)
    }

    if (status == 401 && session.get('token') && !err.config?.suppressAuthRedirect) {
      const { cafeId, country, redirectUri } = getAuthContext()
      session.remove('token')
      router.push({
        path: '/auth',
        query: {
          ...(cafeId ? { cafe_id: cafeId } : {}),
          ...(country ? { country } : {}),
          ...(redirectUri ? { redirect_uri: redirectUri } : {})
        }
      })
    }
    return Promise.reject(err)
  }
)

//export instance
export default instance
